import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import homeSimpleAgentsStore from './store';
import globalStore from '@/store/global';
import fieldCategoryStore from '@/components/field-category/store';
import genFileTypesStore from '../gen-file-types/store';
import client from '@/store/client';
import { HelpOther } from '@/common/helper';
import { Tooltip } from 'antd';
import "./index.scss";
import userStore from '@/store/user';

const HomeSimpleAgents = observer((props) => {
  const store = homeSimpleAgentsStore;

  const list = globalStore?.cloudConfig?.assistantAisoHomeCategoryLine2?.filter((item) => {
    return (+item.is_hide !== 1 && item.category != 'auto')
  }) || [];

  if(!list?.length){
    return null;
  }

  return (
    <div className='mb-16px w-full h-36px relative simple-agents'>
      <div className='flex gap-10px justify-center w-100vw h-36px absolute left-[50%] translate-x-[-50%] transform z-1000'>
        {
          list.map((item, index) => {
            const intro = item.intro || ""
            return (
              <Tooltip 
                key={index}
                overlayClassName="field-category-tooltip" 
                placement="bottomLeft"
                getPopupContainer={node => node}
                arrow={false} 
                align={{offset: [0, 6]}}
                title={
                  intro ? <div className="text-12px text-black text-opacity-70 leading-17px text-left whitespace-normal">{intro}</div> : null
                }
              >
                <div 
                  key={item.category}
                  className={`cursor-pointer relative border-1px border-black border-opacity-16 rounded-8px px-12px h-36px items-center flex bg-white hover:bg-[#f7f7f7] whitespace-nowrap ${item.role_id == store.currentId ? 'rb-current rb-current-small' : ''}`}
                  onClick={
                    () => {
                      if(!item.role_id) {
                        return;
                      }
                      if(!client.isLLQ){
                        HelpOther.toast('去PC端体验完整功能', 'warning');
                        return;
                      }

                      userStore.doWhenLogin(() => {
                        store.setCurrentId(item.role_id);
                        globalStore.robotAiso(false);
                        fieldCategoryStore.reset();
                        genFileTypesStore.reset();
                      });
                    }
                  }>
                  {
                    item.icon
                    ? <img src={item.icon} className='size-16px rounded-full mr-6px' />
                    : null
                  }
                  <div className="truncate">
                    {item.title} 
                  </div>
                </div>
              </Tooltip>
            )
          })
        }
      </div>
    </div>
  )
});
export default HomeSimpleAgents;